import axios from "axios";

const TIMER_VALUE = 60;

// STATE
const state = {
    items: [],
    quantity: 0,
    sumValues: 0,
    sumPricesWithoutTax: 0,
    sumTax: 0,
    sum: 0,
    timer: 0,
    giftCardCartForm: {
        delivery: null,
        paymentFirstName: '',
        paymentLastName: '',
        paymentGender: null,
        paymentStreet: '',
        paymentAdditionalAddress: '',
        paymentPostCode: '',
        paymentCity: '',
        paymentCountry: 'Deutschland',
        paymentEmail: '',
        paymentPhone: '',
        paymentAsCompany: false,
        paymentCompany: '',
        usePaymentInfoForDelivery: true,
        deliveryFirstName: '',
        deliveryLastName: '',
        deliveryGender: null,
        deliveryStreet: '',
        deliveryAdditionalAddress: '',
        deliveryPostCode: '',
        deliveryCity: '',
        deliveryCountry: 'Deutschland',
        deliveryEmail: '',
        deliveryPhone: '',
        deliveryAsCompany: false,
        deliveryCompany: '',
        payment: 'paypal',
        emailSubscribe: false,
        phoneSubscribe: false,
    },
    topUpForm: {
        paymentFirstName: '',
        paymentLastName: '',
        paymentGender: null,
        paymentStreet: '',
        paymentAdditionalAddress: '',
        paymentPostCode: '',
        paymentCity: '',
        paymentCountry: 'Deutschland',
        paymentEmail: '',
        paymentPhone: '',
        paymentAsCompany: false,
        paymentCompany: '',
        payment: 'bank',
        emailSubscribe: false,
        phoneSubscribe: false,
        usePaymentInfoForDelivery: true
    },
    voucherForm: {
        gender: '',
        firstName: '',
        lastName: '',
        street: '',
        additionalAddress: '',
        postcode: '',
        city: '',
        email: '',
        phone: '',
        newCustomer: false,
        emailSubscribe: false,
        phoneSubscribe: false,
        agreement: false,
        company: '',
        asCompany: false,
    }
};

// GETTERS
const getters = {
    items: (state) => state.items,
    quantity: (state) => state.items.reduce((total,  item) => (total + item.quantity), 0),
    sumMoneyValues: (state) => state.items.filter((item) => (item.value.type === 'money')).reduce((total,  item) => (total + (item.value.value * item.quantity)), 0),
    sumSubscriptionValues: (state) => (taxValue = 0) => state.items.filter((item) => (item.value.type === 'subscription')).reduce((total,  item) => (total + (Math.round(item.value.value / (taxValue / 100 + 1) * 100) / 100 * item.quantity)), 0),
    sumValues: (state, getters) => (taxValue = 0) => getters.sumMoneyValues + getters.sumSubscriptionValues(taxValue),
    sumPricesWithoutTax: (state) => (taxValue = 0) => state.items.reduce((total, item) => (total + (Math.round(item.card.price / (taxValue / 100 + 1) * 100) / 100 * item.quantity)), 0),
    sumTax: (state, getters) => (taxValue = 0) =>  getters.sum - getters.sumValues(taxValue) - getters.sumPricesWithoutTax(taxValue),
    sum: (state) => state.items.reduce((total, item) => (total + ((item.value.value + item.card.price ) * item.quantity)), 0),
    timer: (state) => parseInt(state.timer),
    giftCardCartForm: (state) => state.giftCardCartForm,
    topUpForm: (state) => state.topUpForm,
    voucherForm: (state) => state.voucherForm,
};

// ACTIONS
const actions = {
    addItem({commit, getters, dispatch}, item) {
        const index = getters.items.findIndex(i => i.id === item.id && i.value === item.value );
        if (index !== -1) {
            if (getters.items[index].quantity + item.quantity >= getters.items[index].threshold) return;
        }

        return dispatch('setItem', { id: item.id, value: item.value, quantity: item.quantity });
    },

    removeItem({commit, getters, dispatch}, item) {
        commit('removeItem', item);
        return dispatch('setItem', { id: item.id, value: item.value, quantity: 0 });
    },

    addQuantity({commit, getters, dispatch}, item) {
        commit('addQuantity', item);
        return dispatch('setItem', { id: item.id, value: item.value, quantity: 1 });
    },

    removeQuantity({commit, getters, dispatch}, item) {
        commit('removeQuantity', item);
        return dispatch('setItem', { id: item.id, value: item.value, quantity: -1 });
    },

    increment({commit}, item) {
        commit('addQuantity', item);
    },

    decrement({commit}, item) {
        commit('removeQuantity', item);
    },

    getItems({commit}) {
        return new Promise((resolve, reject) => {
            axios.get('/gift-card-cart').then(response => {
                commit('setData', response.data.data);
                resolve(response.data);
            }, error => {
                reject(error.response);
            });
        });
    },

    setItem({commit}, data) {
        return new Promise((resolve, reject) => {
            axios.post('/gift-card-cart',{ id: data.id, value: data.value, quantity: data.quantity }).then(response => {
                if (!data.silent) commit('setData', response.data.data);
                resolve(response.data);
            }, error => {
                reject(error.response);
            });
        });
    },

    initializeTimer({commit, dispatch}) {
        let time = localStorage.getItem('cartTimer');
        if (!time) {
            dispatch('resetTimer');
        } else {
            commit('setTimer', parseInt(time));
        }
    },

    resetTimer({commit}) {
        let currentTime = Date.now().toString();
        localStorage.setItem('cartTimer', currentTime);

        commit('setTimer', parseInt(currentTime));
    }

};

// MUTATIONS
const mutations = {
    setData(state, data) {
        state.items = data.items;
        state.quantity = data.quantity;
        state.sumValues = data.sumValues;
        state.sumPricesWithoutTax = data.sumPricesWithoutTax;
        state.sumTax = data.sumTax;
        state.sum = data.sum;
    },
    addQuantity(state, item) {
        item.quantity++;
    },
    removeQuantity(state, item) {
        item.quantity--;
        if (item.quantity <= 0) {
            state.items.splice(state.items.indexOf(item), 1);
        }
    },
    removeItem(state, item) {
        state.items.splice(state.items.indexOf(item), 1);
    },
    setTimer(state, time) {
        state.timer = time;
    },
    updateGiftCardCartForm(state, formData) {
        state.giftCardCartForm = { ...state.giftCardCartForm, ...formData };
    },
    updateTopUpForm(state, formData) {
        state.topUpForm = { ...state.topUpForm, ...formData };
    },
    updateVoucherForm(state, formData) {
        state.voucherForm = { ...state.voucherForm, ...formData };
    },
};

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
};
